module.exports = __webpack_public_path__ + "img/tu2.e29ecfc3.png";